export default {
  state: {
    globalLoadingState: true,
    globalLoadingHint: ''
  },
  mutations: {
    setGlobalLoading(state, hint) {
      
      if (hint) {
        state.globalLoadingState = true
      } else {
        state.globalLoadingState = false
      }

      state.globalLoadingHint = hint
    }
  },
  actions:{
    async setGlobalLoading({commit}, hint) {
      return await commit('setGlobalLoading', hint)
    }
  },
  getters: {
    globalLoading(state){
      return state.globalLoadingState
    },
    globalLoadingHint(state) {
      return state.globalLoadingHint
    }
  }
}